import React from "react";
import {Button, Paper, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {img} from "@core/utils/string";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 600,
    padding: '30px 30px 20px 30px',
    position: "relative",
    zIndex: 100,
    textAlign: 'center',
    [theme.breakpoints.down(600)]: {
      width: '95%',
      padding: '20px'
    }
  },
  img: {
    width: '90%',
    margin: '0 auto',
    display: 'block'
  },
  actions: {
    marginTop: 20,
    textAlign: "left"
  }
}))

const ForgotPasswordSuccess = (props: {back: () => void, emailOrPhone: string}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const currentMessage = props.emailOrPhone[0] === '+' 
    ? t('success_forgot_pass_sms')
      : t('success_forgot_pass_email');

  return (
    <Paper className={classNames(classes.root, 'root')}>
      <img src={img('email_sent.svg')} alt="" className={classes.img}/>
      <h3 className="text-default">{t('message_sent')}</h3>
      <p className="subtitle">
        {currentMessage} <strong>{props.emailOrPhone}</strong>
      </p>
      <div className={classes.actions}>
        <Button color="secondary" onClick={props.back}>{t('try_again')}</Button>
      </div>
    </Paper>
  )
}

export default ForgotPasswordSuccess;